import axios from 'axios';
import { API_BASE_URL } from './components/baseURL';

class AuthService {
    login(credentials) {
        return axios.post(`${API_BASE_URL}/login`, credentials);
    }
}

export default new AuthService();
